import datapoints from './datapoints';
import restoreConversationService from '../services/restoreConversationService';
import { getApplyConversationActionContext, getRowIdsFromRowKeys } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import filterConversationRowsByRestriction from 'owa-mail-list-store/lib/utils/filterConversationRowsByRestriction';
import { actionNames } from 'owa-mail-store-actions';
import { handleServiceError } from 'owa-service-error';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
var RestoreConversationActionName = 'RestoreConversation';
/**
 * Restore conversations action
 * @param rowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param state the RestoreConversationState which contains the original table view
 * @return the action response
 */
export default select({
    originalTableView: function (conversationRowKeys, tableViewId) {
        return listViewStore.tableViews.get(tableViewId);
    },
})(action(RestoreConversationActionName, datapoints.restoreConversationDatapoint)(function restoreConversations(conversationRowKeys, tableViewId, state) {
    var filteredRowKeys = filterConversationRowsByRestriction(conversationRowKeys, tableViewId, function (tableConversationRelation) { return !!tableConversationRelation; });
    var conversationIdStrings = getRowIdsFromRowKeys(filteredRowKeys, tableViewId);
    var conversationActionContexts = filteredRowKeys.map(function (rowKey) {
        return getApplyConversationActionContext(rowKey, tableViewId);
    });
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = handleServiceError(RestoreConversationActionName, strings.errorRestore, function () {
        var sourceFolderId = state.originalTableView.serverFolderId;
        // Make service request
        return restoreConversationService(conversationActionContexts, sourceFolderId);
    });
    // raise stitch to delete conversation from reading pane, but not undo because we are not in delete items when undoing
    raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, state.originalTableView);
    return actionResponse;
}));
//# sourceMappingURL=restoreConversations.js.map